export default "__VITE_ASSET__DHh$esF6__"